/**
 * 파라미터가 null 또는 undefined 인지 여부를 반환합니다.
 * @param v 검사 대상
 * @returns {boolean} true == null 또는 undefined 임.
 */
export default v => v === undefined || v == null
